import React from 'react';
import './style.css';

export const LoadingSkeleton: React.FC = () => {
  return (
    <div className="skeleton-container">
      {/* 日语部分 */}
      <div className="skeleton-japanese">
        <div className="skeleton-line short" />
        <div className="skeleton-line medium" />
        <div className="skeleton-line short" />
      </div>

      {/* 中文部分 */}
      <div className="skeleton-chinese">
        <div className="skeleton-line medium" />
        <div className="skeleton-line short" />
      </div>
    </div>
  );
};